// import React from 'react'

// const NoPage = () => {
//   return (
//     <div>
//         <h1 style={{ border: '1px solid red', color: 'white', padding: '10px' }}>Page Not Found!!</h1>
//         <p style={{ border: '1px solid red', color: 'white', padding: '10px' }}>The Page you requested for could not be Found</p>
//     </div>
//   )
// }

// export default NoPage



import React from 'react';
import './noPage.css'; 

const NoPage = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <p className="not-found-message">The page you requested for could not be found</p>
      </div>
    </div>
  );
};

export default NoPage;